module.exports = __webpack_public_path__ + "static/media/jac.965ea4e4.jpeg";